import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledInnerBanner = styled.section`
    padding-top: ${theme.innerBanner};
    background-color: ${theme.colors.themeColor7};
    position: relative;

    .title-wrapper-middle {
        position: relative;
        ${theme.flexCol}
        overflow: hidden !important;
        margin-bottom: 30px;

        .swiper__title {
            &:last-child {
                margin-left: 18%;
                margin-top: 10px;
            }
        }

        h2 {
            position: relative;
            transition: ${theme.transition};
            margin: 0 !important;

            ${theme.innerBannerTitle}

            ${devices.md} {
                font-size: ${theme.fontSizes.rem4} !important;
            }
        }

        ${devices.sm} {
            h2 {
                ${theme.innerBannerTitleMobile}
            }

            .swiper__title {
                &:last-child {
                    margin-left: 0;
                    margin-top: 10px;
                }
            }

        }
    }


    &:after {
        content: '';
        background: ${theme.colors.innerBannerTint};
        ${theme.absoluteFill}
        ${theme.viewHeight}
    }


    .container {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 60px;
        z-index: 2;
        padding-top: 40px;
        margin: auto;


        .description_only {
            position: relative;
            padding-top: 30px;

            &:after {
                ${theme.absoluteFillTopTop}
                height: 1px;
                width: 100%;
                background: ${theme.colors.themeColor8};
                margin: 0 auto;
                content: "";
            }

            p {
                color: ${theme.colors.white};
                font-weight: 400;
                font-size: 1rem;
                line-height: 1.2;
                letter-spacing: -0.02em;
                width: 60%;
                ${devices.sm}{
                    width: 100%;
                }
            }
        }


    }


    ${devices.md} {
        padding-top: ${theme.innerBannerMobile};

    }

    ${devices.sm} {
        padding-top: 90svh;

    }

    ${devices.sm60} {
        .title-wrapper-middle h2 {
            ${theme.innerBannerTitleMobile}
        }
    }

`;
